import { render } from "./GaugeChart.vue?vue&type=template&id=1c2171c6&scoped=true"
import script from "./GaugeChart.vue?vue&type=script&lang=js"
export * from "./GaugeChart.vue?vue&type=script&lang=js"

import "./GaugeChart.vue?vue&type=style&index=0&id=1c2171c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2171c6"]])

export default __exports__